import { useIsMutating, useMutationState } from '@tanstack/react-query';
import { apiMutationKeys } from '@/services/apis/apiMutationKeys';
import type { QuoteSummary } from '../apis/getQuoteSummary/schemas';

const useQuoteSummaryMutationState = () => {
  const totalMinCostMutationResponse = useMutationState({
    filters: {
      mutationKey: [...apiMutationKeys.getQuoteSummary],
    },
    select: (mutation) => ({
      data: mutation.state.data as QuoteSummary,
    }),
  });

  const isMutating = useIsMutating({
    mutationKey: [...apiMutationKeys.getQuoteSummary],
  });

  // Get the last mutation response from cache
  return {
    isMutating,
    ...totalMinCostMutationResponse[totalMinCostMutationResponse.length - 1],
  };
};

export { useQuoteSummaryMutationState };
